import { request } from "graphql-request";
import { graphql } from "gql/gql";

import { BACKEND_DOMAIN } from "utils/constants";
import {
    buildRequestHeaders,
} from "utils/helpers";

const queryFn = (accessToken: string, buildingModelCarbonReductionPlanId: string) =>
    request({
        url: `${BACKEND_DOMAIN}/graphql`,
        document: query,
        variables: { buildingModelCarbonReductionPlanId },
        requestHeaders: buildRequestHeaders(accessToken),
    }).then((data) => {
        if (data.buildingModelCarbonReductionPlanReports.error)
            throw new Error(data.buildingModelCarbonReductionPlanReports.error);
        return data.buildingModelCarbonReductionPlanReports
            ?.cumulativeCarbonEmissionsCard as CumulativeCarbonEmissionsCardData;
    });

const query = graphql(`
    query buildingBaselineCumulativeCarbonEmissionsCard(
        $buildingModelCarbonReductionPlanId: Uuid!
    ) {
        buildingModelCarbonReductionPlanReports(buildingModelCarbonReductionPlanId: $buildingModelCarbonReductionPlanId) {
            error
            cumulativeCarbonEmissionsCard {
                totalCarbonEmissions
                totalCarbonEmissionsElectricity
                totalCarbonEmissionsNaturalGas
            }
        }
    }
`);

export default queryFn;
